export default __webpack_public_path__ + "static/media/secondary_login_banner.a8fe268b.png";